export default "/assets/images/checkbox.12910e787e7b66d3f98d4bd85b0c88c9.svg";